export default "__VITE_ASSET__cfbf820b__"